import React from "react";
import PageHero from "../components/PageHero";
import ImpactGrid from "../components/ImpactGrid";
import CtaBanner from "../components/CtaBanner";

function BenefitsImpact() {
  return (
    <>
      <PageHero
        eyebrow="Business impact"
        title="What this changes for HR teams"
        subtitle="The impact of MPeoples HRMS, grounded in the product documentation rather than a scoreboard of numbers."
      />

      <section className="section">
        <div className="container">
          <ImpactGrid />
        </div>
      </section>

      <CtaBanner />
    </>
  );
}

export default BenefitsImpact;
